import type { TopCategory } from '@/api/models';
import { resolveRefDisplay } from '@/components/refLabel';
/**
 * Fixed pixel height for the BarChart so the widget never collapses to
 * zero in containers that don't impose their own height. Matches the
 * design comp's 220px box.
 */
export const BAR_CHART_HEIGHT_PX = 220;

/**
 * Width reserved for the Y-axis (category name) labels under recharts'
 * `layout="vertical"` (visually horizontal bars). Tuned for the longest
 * names in the live data ("Coffee Beans", "Equipment") without
 * truncating; widening here is cheap and avoids per-bar tick logic.
 */
export const Y_AXIS_WIDTH_PX = 120;

/**
 * The rows the bar chart plots, with each category's axis label already
 * resolved.
 *
 * The chart reads its label straight off `categoryName` via `dataKey`, so a
 * deleted category has to be marked before the data reaches it — there is no
 * component in between to wrap. A category the server could not resolve at all
 * becomes `Unknown (id…)` rather than an unlabelled bar (bos-api BOS-122).
 */
export const toChartRows = (
    categories: TopCategory[],
    deletedMarker: string,
    unknownLabel: string,
): TopCategory[] =>
    categories.map((category) => ({
        ...category,
        categoryName: resolveRefDisplay({
            name: category.categoryName,
            id: category.categoryId,
            deleted: category.deleted,
            deletedMarker,
            unknownLabel,
        }).text,
    }));
